import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  rrbs: 0,
  posts: 0,
  users: 0,
  divisions: 0,
  centers: 0,
  exams: 0,
  zones: 0,
  nodal_exam: 0,
  city:0,
  unReadNotif:0,
  shouldUpdate: false, // Flag to track if the sidebar needs to update
  dashboardUpdate: false,
};

export const sidebarCounterSlice = createSlice({
  name: 'sidebarCounter',
  initialState,
  reducers: {
    addsidebarCounter: (state, action) => {
      // Update the sidebar counts
      state.rrbs = action.payload.rrbs;
      state.posts = action.payload.posts;
      state.users = action.payload.users;
      state.divisions = action.payload.divisions;
      state.centers = action.payload.centers;
      state.exams = action.payload.exams;
      state.zones = action.payload.zones;
      state.nodal_exam = action.payload.nodal_exam;
      state.city = action.payload.city
      // Set the shouldUpdate flag to true to indicate an update
      state.shouldUpdate = true;
      state.unReadNotif = action.payload.unReadNotif;
    },

    resetsidebarCounter: (state, action) => {
      // Reset all counts to 0
      state.rrbs = 0;
      state.posts = 0;
      state.users = 0;
      state.divisions = 0;
      state.centers = 0;
      state.exams = 0;
      state.zones = 0;
      state.nodal_exam = 0;
      // Set the shouldUpdate flag to false to indicate reset
      state.shouldUpdate = false;
      state.city = 0;
      state.unReadNotif = 0;
    },

    // Optional: You can manually toggle the shouldUpdate flag if needed
    toggleShouldUpdate: (state) => {
      state.shouldUpdate = !state.shouldUpdate;
    },

    dashboardUpdate: (state)=>{
      state.dashboardUpdate = !state.dashboardUpdate
    }
  },
});

export const { addsidebarCounter, resetsidebarCounter, toggleShouldUpdate,dashboardUpdate } =
  sidebarCounterSlice.actions;

export default sidebarCounterSlice.reducer;
